






import { Component, Vue } from 'vue-property-decorator';
import PageLoader from '@components/common/PageLoader.vue';

/**
 * No.173 — covers a karte popup's form while what it fetches on open is still
 * loading (KarteDraftMixin.isKarteLoading). Shared by both karte popups so the
 * overlay cannot look or behave differently between them.
 *
 * Place it inside the element it should cover, and give that element the
 * `karte-loading-host` class: PageLoader and this overlay position themselves
 * absolutely against it.
 */
@Component({
  components: { PageLoader },
})
export default class KarteLoadingOverlay extends Vue {}
